export const historicalTooltip = {
    body: 'Historical market Venue and Venue Type breakdown in %. This is averaged over the last 20 days.',
};
export const todayTooltip = {
    body: 'Today is the market Venue and Venue Type breakdown in %.',
};
export const orderTooltip = {
    body: "Your order's Venue and Venue Type Breakdown in\xa0%.",
};
